module.exports = __webpack_public_path__ + "static/assets/65d82e34921bc914ad97a28c8b358823.png";